const firebaseConfig = {
    apiKey: "AIzaSyCLQzYifd7hzu6Boqfo-fTQw-js5QjWOXs",
    authDomain: "connection-circle.firebaseapp.com",
    databaseURL: "https://connection-circle.firebaseio.com",
    projectId: "connection-circle",
    storageBucket: "connection-circle.appspot.com",
    messagingSenderId: "183274555302",
    appId: "1:183274555302:web:8c42696e72fbbb34eeb167",
};

export default firebaseConfig;
